import styled from 'styled-components';

import { theme } from '../../ui/themes/default';

export const DeleteDropdownItem = styled.div`
  width: 220px;
  color: ${theme.alertRed};
`;
